import { Box, Button, Container, Typography } from '@mui/material';
import TransparentModel from '../assets/img/HeroBannerModel.png';


const Heromui = ({ setShowForm }) => {
    return (
        <Box
            component="section"
            id="hero"
            sx={{
                position: 'relative',
                pt: { xs: 6, md: 8 },
                // pb: { xs: 8, md: 12 },
                overflow: 'hidden',
                // background: 'linear-gradient(to bottom right,(hsl(217 91% 60% / .05) , hsl(262 83% 58% / .05) , hsl(38 92% 50% / .05))'
                // background: 'linear-gradient(135deg, rgba(124, 58, 237, 0.05) 0%, rgba(16, 185, 129, 0.05) 100%)'
                background: `
                radial-gradient(
                    circle at center,
                    #341D71 0%,
                    rgba(52, 29, 113, 0) 55%
                ),
                radial-gradient(
                    circle at 70% 50%,
                    #582B55 0%,
                    rgba(88, 43, 85, 0) 45%
                ),
                linear-gradient(
                    135deg,
                    #130D4B 0%,
                    #27145B 25%,
                    #341D71 50%,
                    #42215C 75%,
                    #291758 100%
                )
                `,
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', lg: 'repeat(2, 1fr)' },
                    gap: 6,
                    alignItems: 'center'
                }}>
                    {/* Left Content */}
                    <Box
                        sx={{
                            textAlign: { xs: 'left', lg: 'left' },
                            animation: 'fadeIn 0.7s ease-out',
                        }}
                    >
                        <Box
                            component="span"
                            sx={{
                                color: '#ffffff',
                                display: 'inline-block',
                                lineHeight: 1.1,
                                fontSize: '3.5rem',
                                fontWeight: 700,
                            }}
                        >
                            Digitize Your Institute                                 <Box
                                component="span"
                                sx={{
                                    background: 'linear-gradient(173deg, #6F41E3 0%, #E76169 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                }}
                            ><small style={{ fontWeight: '400' }}>with</small> India’s Leading </Box>
                            <br />

                            {/* ONLY this block is relative */}
                            <Box
                                component="span"
                                sx={{
                                    position: 'relative',
                                    display: 'inline-block',
                                }}
                            >
                                {/* Gradient text */}
                                <Box
                                    component="span"
                                    sx={{
                                        background: 'linear-gradient(173deg, #6F41E3 0%, #E76169 100%)',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                    }}
                                >
                                    EdTech Platform
                                </Box>

                                {/* SVG underline */}
                                <Box
                                    component="svg"
                                    viewBox="0 0 280 12"
                                    // viewBox="0 0 100 12"
                                    preserveAspectRatio="none"
                                    sx={{
                                        position: 'absolute',
                                        top: 48,
                                        left: '0%',      // ⬅ centers extra width
                                        bottom: -10,
                                        width: '100%',     // ⬅ increase length
                                        height: 12,
                                    }}
                                >
                                    <path
                                        d="M2 10C70 2 210 2 278 10"
                                        stroke="hsl(16 100% 62%)"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        fill="none"
                                    />
                                </Box>
                            </Box>
                        </Box>



                        <Typography
                            variant="h6"
                            color="text.secondary"
                            sx={{
                                color: '#BBB4CE',
                                fontWeight: 400,
                                fontSize: '1.50rem',
                                lineHeight: 1.7,
                                textTransform: 'none',
                                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
                            }}
                        >
                            Launch Tests. Track Results. Scale Faster.
                            {/* Create test series, deliver performance analytics, and scale your coaching business with India's most powerful EdTech solution. */}
                        </Typography>
                        <Button
                            variant="contained"
                            size="large"
                            // endIcon={<CheckCircleOutlinedIcon />}
                            sx={{
                                mt: 4,
                                mb: 2,
                                borderRadius: 1,
                                textTransform: "none",
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, hsl(16 100% 62%) 0%, #f59f0a 100%)',
                                color: '#fff',
                                float: 'left',
                                fontSize: '0.875rem',
                                lineHeight: '1.25rem',

                            }}
                            onClick={setShowForm}
                        >
                            View Pricing Plans
                        </Button>
                        {/* Floating Elements */}
                        <Box
                            sx={{
                                position: 'absolute',
                                top: -16,
                                right: -16,
                                width: 96,
                                height: 96,
                                bgcolor: 'secondary.main',
                                opacity: 0.2,
                                borderRadius: '50%',
                                filter: 'blur(40px)',
                                animation: 'pulse 2s ease-in-out infinite',
                            }}
                        />
                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: -16,
                                left: -16,
                                width: 128,
                                height: 128,
                                bgcolor: 'primary.main',
                                opacity: 0.2,
                                borderRadius: '50%',
                                filter: 'blur(40px)',
                                animation: 'pulse 2s ease-in-out 1s infinite',
                            }}
                        />
                    </Box>

                    {/* Right Image */}
                    <Box
                        sx={{
                            position: 'relative',
                            animation: 'fadeIn 0.7s ease-out 0.2s both',
                            display: { xs: 'none', lg: 'block' },
                            // boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
                        }}
                    >
                        {/* <Box
                            component="img"
                            src={heroImage}
                            alt="Students learning together with educational technology"
                            sx={{
                                width: '100%',
                                height: 'auto',
                                borderRadius: 4,
                                // boxShadow: '0 10px 40px -10px rgba(0, 0, 0, 0.2)',
                            }}
                        /> */}
                        <Box
                            component="img"
                            src={TransparentModel}
                            alt="EdTech platform preview"
                            sx={{
                                width: '100%',
                                maxWidth: 520,
                                height: 'auto',
                                display: 'block',
                                margin: '0 auto',
                                borderRadius: 4,
                            }}
                        />
                        {/* <LeadGenerationForm isHandleCloseForm={false} /> */}

                        {/* Floating Elements */}
                        {/* <Box
                            sx={{
                                position: 'absolute',
                                top: -16,
                                right: -16,
                                width: 96,
                                height: 96,
                                bgcolor: 'secondary.main',
                                opacity: 0.2,
                                borderRadius: '50%',
                                filter: 'blur(40px)',
                                animation: 'pulse 2s ease-in-out infinite',
                            }}
                        />
                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: -16,
                                left: -16,
                                width: 128,
                                height: 128,
                                bgcolor: 'primary.main',
                                opacity: 0.2,
                                borderRadius: '50%',
                                filter: 'blur(40px)',
                                animation: 'pulse 2s ease-in-out 1s infinite',
                            }}
                        /> */}
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Heromui;
